import React from "react";
import { SVGProps } from "react";

const MenuIcon: React.FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="29"
      height="20"
      viewBox="0 0 29 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7 8H22"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
      <path
        d="M7 13H22"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
    </svg>
  );
};

export default MenuIcon;
